export default __webpack_public_path__ + "static/media/sliver.0f407d23.png";